import React from 'react'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import { TeamsWithColours } from './RoundResults'
import ResultsTeamLineChart from './charts/ResultsTeamLineChart'
import { getYAxisDataV2 } from './charts/yaxis'
import ChartCard from './components/ChartCard'

interface Props {
  pastRound1: boolean
  teams: TeamsWithColours[]
  customerSatisfaction: ModelAPI.Reporting.DataAndPositions
}

const RoundResultsCustomerSatisfaction: React.FC<Props> = ({
  pastRound1,
  teams,
  customerSatisfaction,
}) => {
  const { minValue, maxValue, numberOfTicks } = getYAxisDataV2({
    pastRound1,
    data: customerSatisfaction.data
  })
  return (
    <VerticalGroup full center wide>
      <ChartCard heading='Customer Satisfaction'>
        <ResultsTeamLineChart
          data={customerSatisfaction.data}
          teams={teams}
          minYAxisvalue={minValue}
          maxYAxisvalue={maxValue}
          numberOfTicks={numberOfTicks}
          teamPositions={customerSatisfaction.teamPositions}
        />
      </ChartCard>
    </VerticalGroup>
  )
}

export default RoundResultsCustomerSatisfaction

// "customerSatisfaction": {
//     "data": [
//       {
//         "team3": 0,
//         "team4": 0,
//         "team1": 0,
//         "team2": 0,
//         "name": "Round 0",
//         "team7": 0,
//         "team8": 0,
//         "team5": 0,
//         "team6": 0
//       },
//       {
//         "team3": -1,
//         "team4": 11,
//         "team1": 6,
//         "team2": 11,
//         "name": "Round 1",
//         "team7": 6,
//         "team8": 8,
//         "team5": 4,
//         "team6": -1
//       },
//       {
//         "team3": 0,
//         "team4": 29,
//         "team1": 12,
//         "team2": 31,
//         "name": "Round 2",
//         "team7": 10,
//         "team8": 12,
//         "team5": 17,
//         "team6": -1
//       },
//       {
//         "team3": 1,
//         "team4": 46,
//         "team1": 24,
//         "team2": 48,
//         "name": "Round 3",
//         "team7": 24,
//         "team8": 27,
//         "team5": 36,
//         "team6": 9
//       },
//       {
//         "team3": 8,
//         "team4": 67,
//         "team1": 46,
//         "team2": 64,
//         "name": "Round 4",
//         "team7": 43,
//         "team8": 41,
//         "team5": 57,
//         "team6": 22
//       },
//       {
//         "team3": 20,
//         "team4": 76,
//         "team1": 75,
//         "team2": 71,
//         "name": "Round 5",
//         "team7": 64,
//         "team8": 57,
//         "team5": 68,
//         "team6": 44
//       }
//     ],
//     "teamPositions": [
//       {
//         "teamId": 4,
//         "position": 1
//       },
//       {
//         "teamId": 1,
//         "position": 2
//       },
//       {
//         "teamId": 2,
//         "position": 3
//       }
//     ]
//   },

